import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Box,
  Typography,
  Alert,
  Divider,
  Container,
  InputAdornment,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Visibility, VisibilityOff, CheckCircle, Cancel } from "@mui/icons-material";
import LockResetIcon from "@mui/icons-material/LockReset";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showCriteria, setShowCriteria] = useState(false); // Novo estado para exibir critérios
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");


  const inputStyle = {
  backgroundColor: "#ffffffff",
  color: "#777777e0",
};


  // Função para verificar os critérios da senha
  const validatePasswordCriteria = (password) => ({
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    specialChar: /[@$!%*?&#.]/.test(password),
  });

  const criteria = validatePasswordCriteria(password);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Verifica se todos os critérios foram atendidos
    if (!Object.values(criteria).every(Boolean)) {
      setError("A senha deve atender a todos os critérios de segurança.");
      return;
    }

    if (password !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });


      const data = await response.json();

      if (response.ok) {
        setMessage("Senha redefinida com sucesso!");
        setError("");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setError(data.message || "Erro ao redefinir senha.");
      }
    } catch (error) {
      console.error("Erro ao redefinir senha:", error);
      setError("Erro no servidor. Tente novamente.");
    }
  };

  return (
    <Container maxWidth="xs" style={styles.container}>
      <Box style={styles.box}>
        <LockResetIcon fontSize="large" style={styles.icon} />
        <Typography variant="h5" align="center" style={styles.header}>
          Redefinir Senha
        </Typography>
        <Typography variant="body2" align="center" style={styles.instructions}>
          Crie uma senha que atenda aos critérios de segurança.
        </Typography>
        <Divider style={styles.divider} />
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleResetPassword}>
<TextField
  fullWidth
  label="Nova Senha"
  type={showPassword ? "text" : "password"}
  value={password}
  onFocus={() => setShowCriteria(true)}
  onChange={(e) => setPassword(e.target.value)}
  required
  margin="normal"
  inputProps={{
    style: {
      backgroundColor: "#ffffffff",
      color: "#292929e0",
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
<IconButton
  onClick={() => setShowPassword(!showPassword)}
  edge="end"
  sx={{
    color: showPassword ? "#2069b4" : "#666",
  }}
>
  {showPassword ? <VisibilityOff /> : <Visibility />}
</IconButton>


      </InputAdornment>
    ),
  }}
/>

          {showCriteria && ( // Só mostra os critérios se showCriteria for true
            <Box style={styles.criteriaBox}>
              <Typography variant="body2" style={styles.criteriaTitle}>
                Critérios da Senha:
              </Typography>
              <List dense style={styles.list}>
                <ListItem style={styles.listItem}>
                  {criteria.length ? (
                    <CheckCircle style={styles.iconValid} />
                  ) : (
                    <Cancel style={styles.iconInvalid} />
                  )}
                  <ListItemText primary="Pelo menos 8 caracteres" />
                </ListItem>
                <ListItem style={styles.listItem}>
                  {criteria.uppercase ? (
                    <CheckCircle style={styles.iconValid} />
                  ) : (
                    <Cancel style={styles.iconInvalid} />
                  )}
                  <ListItemText primary="Uma letra maiúscula" />
                </ListItem>
                <ListItem style={styles.listItem}>
                  {criteria.lowercase ? (
                    <CheckCircle style={styles.iconValid} />
                  ) : (
                    <Cancel style={styles.iconInvalid} />
                  )}
                  <ListItemText primary="Uma letra minúscula" />
                </ListItem>
                <ListItem style={styles.listItem}>
                  {criteria.number ? (
                    <CheckCircle style={styles.iconValid} />
                  ) : (
                    <Cancel style={styles.iconInvalid} />
                  )}
                  <ListItemText primary="Um número" />
                </ListItem>
                <ListItem style={styles.listItem}>
                  {criteria.specialChar ? (
                    <CheckCircle style={styles.iconValid} />
                  ) : (
                    <Cancel style={styles.iconInvalid} />
                  )}
                  <ListItemText primary="Um caractere especial (@$!%*?&#.)" />
                </ListItem>
              </List>
            </Box>
          )}
         <TextField
  fullWidth
  label="Confirmar Senha"
  type={showPassword ? "text" : "password"}
  value={confirmPassword}
  onChange={(e) => setConfirmPassword(e.target.value)}
  required
  margin="normal"
  inputProps={{
    style: {
      backgroundColor: "#ffffffff",
      color: "#292929e0",
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
<IconButton
  onClick={() => setShowPassword(!showPassword)}
  edge="end"
  sx={{
    color: showPassword ? "#2069b4" : "#666",
  }}
>
  {showPassword ? <VisibilityOff /> : <Visibility />}
</IconButton>

      </InputAdornment>
    ),
  }}
/>

          <Button
            fullWidth
            variant="contained"
            style={styles.button}
            type="submit"
          >
            Redefinir Senha
          </Button>
        </form>
      </Box>
    </Container>
  );
}

const styles = {
  container: {
    marginTop: "50px",
    backgroundColor: "#ffffff",
    color: "#333",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  icon: {
    color: "#2069b4",
    marginBottom: "10px",
  },
  header: {
    color: "#333",
    marginBottom: "10px",
    fontWeight: "bold",
  },
  instructions: {
    color: "#666",
    marginBottom: "20px",
  },
  divider: {
    width: "100%",
    backgroundColor: "#ddd",
    margin: "10px 0",
  },
  criteriaBox: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  criteriaTitle: {
    color: "#333",
    fontWeight: "bold",
  },
  list: {
    padding: 0,
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  iconValid: {
    color: "green",
    fontSize: "18px",
    marginRight: "10px",
  },
  iconInvalid: {
    color: "red",
    fontSize: "18px",
    marginRight: "10px",
  },
  button: {
    marginTop: "20px",
    backgroundColor: "#2069b4",
    color: "#fff",
    padding: "10px 20px",
    fontWeight: "bold",
    borderRadius: "5px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#185a90",
    },
  },
};

export default ResetPassword;
